<template>
    <p class="text-center">No hay elementos para mostrar</p>
</template>
<script>
export default {
  name: 'EditTerms',
}
</script>
<style scoped>
</style>